// İSG uzmanı portalı — Risk seviye rozeti (5x5 L-tipi band). Token'lı ısı skalası (literal renk
// YOK — bkz. tokens.css `--color-risk-*`): Onemsiz=yeşil, Dusuk=mavi, Orta=sarı, Yuksek=turuncu,
// KabulEdilemez=kırmızı. Etiket i18n'den (`risk.level.<value>`); opsiyonel skor (P×S) parantezde.
//
// **⛔ level DEĞERİ girdi olarak verilir — bileşen türetmez.** Kalıcı band her zaman sunucudan
// gelir (§19); matris seçicideki canlı önizleme de `level` prop'unu (deriveLevel çıktısı) geçirir.

import { cn } from '@isgportal/shared';
import type { RiskLevel } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { RISK_LEVEL_CLASS } from './riskLevelStyles';

interface RiskLevelBadgeProps {
  level: RiskLevel;
  /** Opsiyonel skor (P×S) — verilirse etiketten sonra parantezde gösterilir. */
  score?: number | null;
  className?: string;
}

export function RiskLevelBadge({ level, score, className }: RiskLevelBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold',
        RISK_LEVEL_CLASS[level],
        className,
      )}
    >
      {t(`risk.level.${level}`)}
      {typeof score === 'number' ? (
        <span className="tabular-nums opacity-90">({score})</span>
      ) : null}
    </span>
  );
}
